(function() {
  'use strict';
  function esc(s) { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  var data = {}, done = {};

  function init() {
    var el = document.getElementById('B2BRecsData');
    if (!el) return;
    try { data = JSON.parse(el.textContent); } catch(e) { return; }
    if (!Object.keys(data).length) return;
    setTimeout(go, 1000);
    setTimeout(go, 3000);
    setTimeout(go, 7000);
  }

  function go() {
    // Find parent product links (no ?variant=)
    var links = document.querySelectorAll('a[href*="/products/"]');
    links.forEach(function(lk) {
      var href = lk.href;
      if (href.indexOf('?variant=') >= 0) return;
      var m = href.match(/\/products\/(.+?)(?:\?|$)/);
      if (!m) return;
      var h = m[1];
      if (!h || done[h]) return;
      done[h] = 1;
      var items = data[h];
      if (!items || !items.length) return;

      var row = lk.closest('tr') || lk.closest('[class*="product"]') || lk.closest('div');
      if (!row || row.querySelector('.b2b-rec-btn')) return;

      // Build toggle + panel
      var wrap = document.createElement('div');
      wrap.style.cssText = 'padding:6px 0 8px 0';

      var btn = document.createElement('button');
      btn.className = 'b2b-rec-btn';
      btn.style.cssText = 'display:inline-block;font-size:11px;cursor:pointer;background:none;border:1px solid #3366cc;color:#3366cc;padding:4px 10px;border-radius:3px';
      btn.textContent = '▶ Recommended Products (' + items.length + ')';

      var panel = document.createElement('div');
      panel.style.cssText = 'display:none;padding:6px 0';

      btn.onclick = function() {
        var open = panel.style.display === 'block';
        panel.style.display = open ? 'none' : 'block';
        btn.textContent = (open ? '▶' : '▼') + ' Recommended Products (' + items.length + ')';
        if (!open && !panel.dataset.loaded) renderPanel(panel, items);
      };

      wrap.appendChild(btn);
      wrap.appendChild(panel);
      row.insertAdjacentElement('afterend', wrap);
    });
  }

  function renderPanel(panel, items) {
    panel.dataset.loaded = '1';
    var c = document.createElement('div');
    c.style.cssText = 'display:flex;gap:10px;overflow-x:auto;padding:4px 0';

    items.forEach(function(p) {
      var card = document.createElement('div');
      card.style.cssText = 'min-width:155px;border:1px solid #ddd;border-radius:6px;padding:10px;text-align:center;flex-shrink:0';
      card.innerHTML =
        '<a href="/products/' + p.h + '">' +
          (p.i ? '<img src="' + esc(p.i) + '" alt="' + esc(p.t) + '" style="width:64px;height:64px;object-fit:cover;border-radius:4px;margin:0 auto 5px;display:block" loading="lazy">' : '') +
        '</a>' +
        '<div style="font-size:10.5px;line-height:1.2;margin-bottom:3px"><a href="/products/' + p.h + '" style="color:#333;text-decoration:none">' + esc(p.t) + '</a></div>' +
        '<div style="font-weight:600;font-size:12px;margin-bottom:5px">' + esc(p.pf) + '</div>' +
        '<button data-vid="' + p.vr + '" style="width:100%;padding:4px 0;border:1px solid #3366cc;background:none;color:#3366cc;border-radius:3px;font-size:10.5px;cursor:pointer;font-weight:500">Add to Cart</button>';

      card.querySelector('button').addEventListener('click', function(e) {
        e.stopPropagation();
        var b = this, vid = parseInt(this.dataset.vid);
        b.disabled = true; b.textContent = '...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
        })
        .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function() {
          b.textContent = '✓ Added';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function() { b.textContent = 'Add to Cart'; b.disabled = false; }, 2000);
        })
        .catch(function() { b.textContent = 'Error'; b.disabled = false; });
      });

      c.appendChild(card);
    });

    panel.appendChild(c);
  }

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();
})();
